export function downloadFile(filename, text, type="text/plain") {
	// Create an invisible A element
	const a = document.createElement("a");
	a.style.display = "none";
	document.body.appendChild(a);
  
	// Set the HREF to a Blob representation of the data to be downloaded
	a.href = window.URL.createObjectURL(
	  new Blob([text], { type })
	);
  
	// Use download attribute to set set desired file name
	a.setAttribute("download", filename);
  
	// Trigger the download by simulating click
	a.click();
  
	// Cleanup
	window.URL.revokeObjectURL(a.href);
	document.body.removeChild(a);
}

export function view_doc_MakeASaveAsName_CleanUp(docname: string)
{
	docname = docname.replace(/:/g, '');
	docname = docname.replace(/\*/g, '');
	docname = docname.replace(/\?/g, '');
	docname = docname.replace(/\"/g, '');
	docname = docname.replace(/</g, '');
	docname = docname.replace(/>/g, '');	
	docname = docname.replace(/\|/g, '');
	docname = docname.replace(/\//g, '');
	docname = docname.replace(/\\/g, '');
	
	docname = docname.trim();
	
	return docname;
}

export function formatDate(date: Date | null){
	if (!date) return '';
	return date.toLocaleDateString('en-CA', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	});
}